import Button from './Button';

export default function Error() {
    return(
        <div className="loading-page">
            <h3>Vabandust, midagi läks valesti. Palun proovi uuesti!</h3>
            <Button text={"Proovi uuesti"} href={"/"} type={'btn btn-primary'} />
        </div>
    )
}